import { render, staticRenderFns } from "./CategorySortSecondary.vue?vue&type=template&id=ab948f6a&"
import script from "./CategorySortSecondary.vue?vue&type=script&lang=js&"
export * from "./CategorySortSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {CategorySortRowActions: require('/lasso/components/questions/CategorySortRowActions.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab948f6a')) {
      api.createRecord('ab948f6a', component.options)
    } else {
      api.reload('ab948f6a', component.options)
    }
    module.hot.accept("./CategorySortSecondary.vue?vue&type=template&id=ab948f6a&", function () {
      api.rerender('ab948f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/CategorySortSecondary.vue"
export default component.exports